export default __webpack_public_path__ + "static/media/food-secure-mig-prep.32704993.csv";